import React, { Component } from 'react'
import Feature from 'components/Feature'
import styled from 'react-emotion'
import { color, spacer, typography, SwitchInput } from 'stylist'
import { itemsToSentences } from 'utils/transcript_tools'
import { formatTime } from 'utils/time'
import { FadeIn } from 'components/animation'
import { flatten } from 'utils/fp'
import ReactList from 'react-list'

const SentenceContainer = styled.div`
  max-height: 300px;
  overflow-y: scroll;
`
const Sentence = styled.div`
  color: ${({ current }) => (current ? color('ink') : color('slate'))};
  padding: ${spacer('2')};
  line-height: ${spacer('3')};
  font-weight: ${({ current }) => (current ? 'bold' : 'medium')};
  background-color: ${({ highlight }) =>
    highlight ? 'rgba(206, 245, 212, 0.25)' : color('white')};
`

const SentenceTime = styled.div`
  color: ${color('cadet')};
  padding: ${spacer('2')};
  line-height: ${spacer('3')};
  font-size: 10px;
`

const TranscriptHeader = styled.div`
  ${typography('title1')};
`

const TranscriptWrapper = styled.div`
  background: ${color('white')};
  padding: ${spacer('2')};
`

const TranscriptContainer = styled.div`
  grid-area: transcript;
`

const SentenceGrid = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  cursor: pointer;
`

const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  color: ${color('ink')};
  padding: ${spacer('3')};
`

const isCurrentSentence = (item, currentTime) =>
  item.startTime < currentTime && item.endTime > currentTime

const isHighlightSentence = (item, clipsToShow) =>
  clipsToShow.some(
    clip => item.startTime >= clip.startTime && item.endTime <= clip.endTime
  )

class Transcript extends Component {
  reactListRef = React.createRef()

  state = {
    flattenedItems: [],
    autoScroll: true
  }

  handleSentenceScroll = event => this.setState({ autoScroll: false })

  componentDidUpdate() {
    const list = this.reactListRef.current

    const { currentTime } = this.props
    const { flattenedItems, autoScroll } = this.state

    const currentIndex = flattenedItems.findIndex(item =>
      isCurrentSentence(item, currentTime)
    )

    if (currentIndex > 3 && autoScroll) {
      list.scrollTo(currentIndex - 3)
    }
  }

  render = () => {
    const { items, currentTime, clipsToShow, seekToTime } = this.props

    if (!items) {
      return null
    }

    if (!this.state.flattenedItems.length) {
      this.setState({ flattenedItems: itemsToSentences(flatten(items)) })
    }

    const { flattenedItems } = this.state

    return (
      <Feature
        name="show_transcript"
        fallback={() => {}}
        render={() => (
          <TranscriptContainer>
            <TitleContainer>
              <TranscriptHeader>Transcript</TranscriptHeader>

              <SwitchInput
                id="switch"
                checked={this.state.autoScroll}
                label="Auto Scroll"
                onChange={e =>
                  this.setState(({ autoScroll }) => ({
                    autoScroll: !autoScroll
                  }))
                }
              />
            </TitleContainer>
            <FadeIn>
              <TranscriptWrapper>
                <SentenceContainer onWheel={e => this.handleSentenceScroll(e)}>
                  <ReactList
                    ref={this.reactListRef}
                    length={flattenedItems.length}
                    itemRenderer={(index, key) => (
                      <SentenceGrid
                        onClick={() =>
                          seekToTime(flattenedItems[index].startTime)
                        }
                      >
                        <SentenceTime
                          current={isCurrentSentence(
                            flattenedItems[index],
                            currentTime
                          )}
                        >
                          {formatTime(flattenedItems[index].startTime)}
                        </SentenceTime>
                        <Sentence
                          current={isCurrentSentence(
                            flattenedItems[index],
                            currentTime
                          )}
                          highlight={isHighlightSentence(
                            flattenedItems[index],
                            clipsToShow
                          )}
                        >
                          {flattenedItems[index].sentence}
                        </Sentence>
                      </SentenceGrid>
                    )}
                  />
                </SentenceContainer>
              </TranscriptWrapper>
            </FadeIn>
          </TranscriptContainer>
        )}
      />
    )
  }
}

export default Transcript



// WEBPACK FOOTER //
// ./src/routes/video/components/TranscriptV2.js